<script>
    import ScheduleBox from './ScheduleBox.svelte'
    import { onMount, afterUpdate } from 'svelte';
    import { current_lang,  x_scroll_pos_history } from '../stores.js';

    export let venues;
    export let hours;
    export let artists;

    let venue_height = 90;
    let hour_width = 240;

    let day_start = 14;

    function get_venues_with_artists(){
        let venues_with_artists = [];
        for(let i = 0; i < venues.length; i++){
            let venue_artists = get_artists_for_venue(venues[i].id, i);
            venues_with_artists.push(venue_artists);
        }
        return venues_with_artists;
    }

    function order_by_start_time(artists){
        artists.sort((a, b) => {
            if ( a.time < b.time ){
                return -1;
            }
            if ( a.time > b.time ){
                return 1;
            }
            return 0;
        });
        return artists;
    }

    function get_artists_for_venue(venue_id, venue_order = null){
        let artists_for_venue = [];
        for(let i = 0; i < artists.length; i++){
            let artist = artists[i];
            let shows_for_venue = get_artist_shows_for_venue(artist.shows, venue_id);
            if(shows_for_venue.length > 0){
                for(let n = 0; n < shows_for_venue.length; n++){
                    let appearance_info = structure_appearance_info_for_box(artist, shows_for_venue[n]);
                    artists_for_venue.push(appearance_info);
                }
            }
        }

        artists_for_venue = order_by_start_time(artists_for_venue);

        return artists_for_venue;
    }

    function structure_appearance_info_for_box(artist, appearance){
        let appearance_info = {
            "id": artist.id,
            "name": artist.title,
            "time": appearance.startTime,
            "duration": appearance.duration,
            //used for last artists in main stage (if they don't have duration set)
            "hide_end_time": false,
        };      
        return appearance_info;
    }

    function get_artist_shows_for_venue(shows, venue_id){
        let shows_for_venue = [];
        for(let i = 0; i < shows.length; i++){
            if(shows[i].place.term_id == venue_id){
                shows_for_venue.push(shows[i]);
            }
        }
        return shows_for_venue;
    }

    let box;
    let x_scroll = 0;

    function parseScroll() {
        x_scroll = box.scrollLeft;
        //y_scroll = box.scrollTop
        $x_scroll_pos_history = x_scroll;
    }

    let venue_artists = null;

    onMount(() => {
        if(artists != null && artists.length > 0){
            venue_artists = get_venues_with_artists();
        }

        if($x_scroll_pos_history != null){
            box.scrollLeft = $x_scroll_pos_history;
        }
    });

	afterUpdate(() => {
        if(artists != null && artists.length > 0){
		    venue_artists = get_venues_with_artists();
        }

        if($x_scroll_pos_history != null){
            box.scrollLeft = $x_scroll_pos_history;
        }else{
            x_scroll = 0;
            box.scrollLeft = 0;
        }
	});
</script>
<div class="schedule-main-container">
    <div class="venues">
        <div class="spacer"><span>{#if $current_lang == "FI"}Klo{/if}</span></div>
        <div class="venue-list">
            {#each venues as venue}
            <div class="venue">
                <span>{@html venue.name}</span>
            </div>
            {/each}
        </div>
    </div>
    <div class="scroll-container" bind:this={box} on:scroll={parseScroll}>
        <div class="hours">
            {#each hours as hour}
                <div class="hour" id="hour-{hour}">
                    <span>{hour}.00</span>
                </div>
            {/each}
        </div>
        <div class="shows">
            <div class="hour-columns">
                {#each hours as hour}
                    <div class="hour-column"></div>
                {/each}
            </div>
            <div class="performances">
                {#if venue_artists != null && venue_artists.length > 0}
                    {#each venue_artists as venue_dudes, i}
                        {#if venue_dudes}
                            {#each venue_dudes as artist}
                                <ScheduleBox {day_start} {artist} venue_order={i} {venue_height} {hour_width} />
                            {/each}
                        {/if}
                    {/each}
                {/if}
            </div>
        </div>
    </div>
</div>

<style>
    :root{
        --hour-width: 240px;
        --venue-height: 90px;
    }
    .schedule-main-container{
        display: grid;
        grid-template-columns: 90px 1fr;
        grid-template-rows: auto;
        height: 100%;
        background-color: #fff;
    }
    .venues{
        background-color: #000;
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: 30px 1fr;

        /* background-color: #fff; */
    }
    .venue-list{
        background-color: #000;
        flex-grow: 1;
        height: 100%;

        /* background-color: #fff;
        border-right: 1px solid var(--darker-medium-color); */
    }
    .venue{
        color: #fff;
        height: var(--venue-height);
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        border-bottom: 2px solid #fff;
        font-family: 'futura-pt', sans-serif;
        text-transform: none;
        font-weight: 700;
        font-size: 0.9rem;
        box-sizing: border-box;
        padding: 0 5px;
        text-align: center;

        /* color: #000;
        border-bottom: 1px solid var(--darker-medium-color); */
    }

    :global(.venue span svg){
        fill: #fff;
    }

    .spacer{
        height: 30px;
        background-color: var(--light-color);
        border-right: 1px solid var(--darker-medium-color);
        font-weight: 700;
        font-size: 0.8rem;
        text-transform: none;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }
    .scroll-container{
        margin: 0;
        padding: 0;
        width: 100%;
        overflow: auto;
        white-space: nowrap;
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: 30px 1fr;
    }
    .hours{
        height:30px;
        background-color: var(--light-color);
        box-sizing: border-box;
    }
    .hour{
        display: inline-flex;
        justify-content: center;
        align-items: flex-start;
        flex-direction: column;
        width: var(--hour-width);
        height: 100%;
        background-color: var(--light-color);
        box-sizing: border-box;
        font-weight: 700;
        font-size: 0.8rem;
        padding-left: 5px;
    }
    .hour:not(:last-of-type){
        border-right: 1px solid var(--darker-medium-color);
    }

    .shows{
        background-color: #fff;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        flex-direction: row;
        height: 100%;
        position: relative;
    }
    .hour-columns{
        position: absolute;
        left: 0;
        top: 0;
        /* TODO fix:
        jos korkeus ja leveys on 100%, niin scrollaus menee oudoksi (kännykällä testattuna)
        */
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        display: flex;
    }
    .hour-columns{
        z-index: 1;
    }
    .hour-column{
        display: inline-block;
        width: var(--hour-width);
        flex-grow:1;
        border-right: 1px solid var(--light-color);
        box-sizing: border-box;
    }
    /* .hour-column:nth-child(even){
        background-color: rgb(253, 253, 253);
    } */
    .performances{
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
    }
</style>